var map = {
	"./Cow.svg": 1344,
	"./Dog.svg": 1345,
	"./Dragon.svg": 1346,
	"./Goat.svg": 1347,
	"./Horse.svg": 1348,
	"./Monkey.svg": 1349,
	"./Ox.svg": 1350,
	"./Pig.svg": 1351,
	"./Rabbit.svg": 1352,
	"./Rat.svg": 1353,
	"./Rooster.svg": 1354,
	"./Snake.svg": 1355,
	"./Tiger.svg": 1356
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/cz_icon ^\.\/.*\.svg$
// module id = 209
// module chunks = 0